import { useTheme } from '@mui/material/styles';
import { cardStyles, containerStyles, buttonStyles, textStyles, layoutStyles } from './componentStyles';

/**
 * Custom hook to access and use consistent component styles
 * 
 * @returns {Object} Object containing style objects for different components
 * 
 * Usage example:
 * const styles = useComponentStyles();
 * 
 * <Card sx={styles.cards.gradient}>...</Card>
 * 
 * Note: Default card style (styles.cards.default) has no shadow, just a subtle border
 * For elevated cards with shadow, use styles.cards.elevated instead
 */
const useComponentStyles = () => {
  const theme = useTheme();
  
  // Process any styles that need theme access
  const processThemeStyles = (styleObject) => {
    const processed = {};
    
    for (const key in styleObject) {
      const style = styleObject[key];
      
      if (typeof style === 'function') {
        processed[key] = style(theme);
      } else if (typeof style === 'object' && style !== null) {
        processed[key] = processThemeStyles(style);
      } else {
        processed[key] = style;
      }
    }
    
    return processed;
  };
  
  return {
    cards: processThemeStyles(cardStyles),
    containers: processThemeStyles(containerStyles),
    buttons: processThemeStyles(buttonStyles),
    text: processThemeStyles(textStyles),
    layout: processThemeStyles(layoutStyles),
  };
};

export default useComponentStyles; 